module.exports = __webpack_public_path__ + "img/snappicture_02.99e738e5.jpg";